if (!customElements.get('scroll-hook-trigger')) {
  customElements.define(
    'scroll-hook-trigger',
    class ScrollHookTrigger extends HTMLElement {
      connectedCallback() {
        this.storageKey = `scroll-hook-popup-shown-${this.dataset.modal}`;
        this.sensitivity = parseInt(this.dataset.sensitivity, 10) || 0;
        this.armDelay = parseInt(this.dataset.armDelay, 10) || 0;

        this.wireDismissButton();
        this.wireCtaButton();

        if (sessionStorage.getItem(this.storageKey)) return;

        this.boundHandleMouseOut = this.handleMouseOut.bind(this);

        // Wait a beat before arming so the popup can't fire on page load while
        // the cursor is already parked up near the tab strip.
        this.armTimer = setTimeout(() => {
          document.addEventListener('mouseout', this.boundHandleMouseOut);
        }, this.armDelay);
      }

      disconnectedCallback() {
        this.disarm();
      }

      handleMouseOut(event) {
        // Leaving for another element on the page, not for the browser chrome.
        if (event.relatedTarget) return;

        // Only the top edge counts: that's the direction of the close button,
        // the tab strip and the address bar. Sideways and downward exits are
        // usually just the cursor slipping off, so they're ignored.
        if (event.clientY > this.sensitivity) return;

        this.disarm();
        sessionStorage.setItem(this.storageKey, 'true');
        document.getElementById(this.dataset.modal)?.show();
      }

      disarm() {
        clearTimeout(this.armTimer);
        document.removeEventListener('mouseout', this.boundHandleMouseOut);
      }

      wireDismissButton() {
        const modal = document.getElementById(this.dataset.modal);
        const dismissButton = modal?.querySelector('[data-scroll-hook-dismiss]');
        dismissButton?.addEventListener('click', () => modal.hide());
      }

      wireCtaButton() {
        const modal = document.getElementById(this.dataset.modal);
        const ctaButton = modal?.querySelector('.scroll-hook-popup__cta');
        if (!modal || !ctaButton) return;

        ctaButton.addEventListener('click', (event) => {
          event.preventDefault();
          modal.hide();
        });
      }
    }
  );
}
